import styled from 'styled-components'

export const List = styled.ul`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 0;
    list-style: none;
    
    & > li
    {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
    
    
    li a
    {
        display: inline-flex;
        box-sizing: border-box;
        align-items: center;
        padding: 4px;
        min-height: 26px;
        min-width: 26px;
        justify-content: center;
        border-radius: 64px;
        background-color: transparent;
        color: #000;
        font-family: 'Noto Sans', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0px;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    
    li.active a
    {
        background-color: #D7DBE0;
        color: #000;
    }
    
    li a:hover
    {
        color: #fff !important;
        background-color: #4378FF !important;
    }
    
    li.hidden
    {
        display: none!important;
    }
    
    li.disabled
    {
        
    }
    
    img{
      border: 3px solid #F4F6FC;
      border-radius: 20px;
      padding: 7px;
    }
    
    img.right{
      transform: matrix(-1, 0, 0, 1, 0, 0);
    }
`

export const ArrowButton = styled.button`
  width: 36px;
  height: 26px;
  padding: 4px 8px;
  border: none;
  background: transparent;
  border-radius: 64px;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #E1E6EC;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    
    &:hover {
      background-color: transparent;
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const PageInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PageInput = styled.input`
  box-sizing: border-box;
  padding: 3px 14px;
  border: 1px solid #E1E6EC;
  border-radius: 12px;
  max-width: 60px;
  width: 100%;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  &::placeholder{
    color: #7F818D;
  }

  &:focus{
    -webkit-box-shadow: 0 0 0 30px #FAFAFA inset !important;
    outline: 0;
  }
`;

export const PageButton = styled.button`
  height: 26px;
  padding: 4px 8px;
  margin-left: 5px;
  width: 100%;
  border: none;
  background: #EFF2F5;
  border-radius: 64px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #4378FF;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    opacity: 1;
  }
`;